/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import './Header.scss';
import { getInitials } from '../../utils';
import { useAuth } from '../../hooks/useAuth';
import { useRoleContext } from '../../hooks/useRoleContext';
import usePermissions from '../../hooks/usePermissions';
import useAxios from '../../hooks/useAxios';
import BayerLogo from '../../assets/icons/Bayer-logo.png';
import UserDropdown from '../../assets/images/user-dropdown.jpg';

const Header = () => {
  const { role } = useRoleContext();
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();
  const [nameInitial, setNameInitial] = useState<any>(null);
  const menuLeft = useRef<any>(null);
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState<any>([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { logout } = useAuth();
  const toast = useRef<any>(null);
  const { post } = useAxios();
  const [isOption, setIsOption] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const suggestionListRef = useRef<HTMLDivElement>(null);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const advancedSearchRef = useRef<HTMLDivElement>(null);
  const advanceSearchTitle = useRef<HTMLDivElement>(null);

  const handleLogout = () => {
    logout();
  };

  const userMenuItems = [
    ...(role === 'admin'
      ? [
        {
          label: 'Manage Users',
          icon: 'pi pi-plus',
          command: () => navigate('/manage-users'),
          visible: hasPermission('manage-users', role),
        },
      ]
      : []),
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: handleLogout,
    },
  ];

  useEffect(() => {
    const uname = localStorage.getItem('username');
    setNameInitial(getInitials(uname));
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current && !inputRef.current.contains(event.target as Node)
        && suggestionListRef.current && !suggestionListRef.current.contains(event.target as Node)
      ) {
        setIsOption(false);
        setShowAdvancedSearch(false);
      } if (advanceSearchTitle.current && !advanceSearchTitle.current.contains(event.target as Node)
        && advancedSearchRef.current && !advancedSearchRef.current.contains(event.target as Node)) {
        setShowAdvancedSearch(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="header-inner items-center py-3 bg-white shadow">

      {/* Left Logo */}
      <div className="header-logo-container flex items-center">
        <img src={BayerLogo} alt="logo" title="Bayer" className="h-10 w-auto" />
      </div>

      {/* Right User Info */}
      <div className="header-user-info flex items-center gap-4">

        {/* User Box */}
        <div
          className=" user-info-container flex items-center bg-white rounded-lg shadow-md px-2 py-2 cursor-pointer"
          onClick={(event) => menuLeft?.current?.toggle(event)}
        >
          <img src={`https://ui-avatars.com/api/?name=${encodeURIComponent(nameInitial)}&background=2D3748&color=fff&rounded=true&size=40`} alt="user Logo" className="user-logo" />
          <div className="user-text text-sm leading-tight">
            <div className="font-medium text-gray-900">{nameInitial}</div>
            <div className="text-gray-500 text-xs">{role}</div>
          </div>
          <img src={UserDropdown} alt=">" className="user-drop" />
        </div>

        <Menu model={userMenuItems} ref={menuLeft} popup />
      </div>

      <Toast ref={toast} />
    </div>
  );

};

export default Header;
